/**
 * Close a Preline hs-overlay by id and scrub any leftover backdrop / body lock.
 * Credit checkout success previously only flipped React state, leaving Preline's
 * `.hs-overlay-backdrop` in place — which trapped the page behind a sticky blur.
 */
export function closeHsOverlay(modalId: string): void {
  if (typeof document === "undefined") return;

  const modal = document.getElementById(modalId);
  const hsOverlay = (window as unknown as { HSOverlay?: { close?: (el: HTMLElement) => void } }).HSOverlay;
  if (modal && hsOverlay && typeof hsOverlay.close === "function") {
    hsOverlay.close(modal);
  }

  document.querySelectorAll(".hs-overlay-backdrop").forEach((el) => el.remove());
  document.body.classList.remove("overflow-hidden", "hs-overlay-body-open");
  document.documentElement.classList.remove("hs-overlay-body-open");
  // preline@1.7.0 locks scroll via inline style, not only CSS classes.
  document.body.style.overflow = "";
}
